import { Skeleton } from '@mui/material';

function ListItemSkeleton() {
  return <Skeleton width="100%" height={50} />;
}

export default ListItemSkeleton;
